import React, {Component} from 'react';
import {Navbar, Nav, NavItem} from 'react-bootstrap';
import {connect} from 'react-redux';

import {userActions} from '../../../store/Actions';
//import logo from '../../../assets/Logo_Transparent.png';
//import logo from '../../../assets/Logo_Black_Background.jpg';
import logo from '../../../assets/Buzz_Logo_2019_NEW.png';

class Header extends Component {

    handleUserSelect = (k, e) => {
        e.preventDefault();
        this.props.dispatch(userActions.logout());
    }

    render(){
        return (
            <Navbar collapseOnSelect inverse>
                <Navbar.Header>
                    <Navbar.Brand>
                        <img src={logo} title='BuZZ' alt='BuZZ'/>
                    </Navbar.Brand>
                    <Navbar.Toggle />
                </Navbar.Header>
                <Navbar.Collapse>
                    <Nav pullRight onSelect={(k, e) => this.handleUserSelect(k, e)}>
                        <NavItem eventKey="menu">
                            Logout
                        </NavItem>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        );
    }
}

export default connect()(Header);